import { getField, updateField } from 'vuex-map-fields'

export const state = {
	landingPage: {
		email: ''
	},

	signIn: {
		email: '',
		password: ''
	},

	forgotPassword: {
		email: ''
	},

	signUp: {
		hostFirstName: '',
		hostLastName: '',
		// hostEmail: '',
		companyName: '',
		companyEmail: '',

		// companyType: {},
		// sessionType: [],

		password: '',
		confirmPassword: '',

		buildingName: '',
		street: '',
		city: '',
		zipCode: '',

		country: {},

		timeZone: {},

		countryCode: {},

		contactNo: '',

		// phoneNumber: '',

		// category: {},

		userAllocation: ''
	},

	changePassword: {
		newPassword: '',
		confirmPassword: ''
	},

	signUpformIsEmpty: false,
	isCheckedAll: false,

	agree: false
}

export const mutations = {
	updateField,

	clearSignIn (state) {
		state.signIn = {
			email: '',
			password: ''
		}
	},

	clearSignUp (state) {
		state.signUp = {
			hostFirstName: '',
			hostLastName: '',
			// hostEmail: '',
			companyName: '',
			companyEmail: '',

			// companyType: {},
			// sessionType: [],

			password: '',
			confirmPassword: '',

			buildingName: '',
			street: '',
			city: '',
			zipCode: '',

			country: {},

			timeZone: {},

			countryCode: {},

			contactNo: '',

			// phoneNumber: '',

			// category: {},

			userAllocation: ''
		}

		state.agree = false
	},

	clearForgotPassword (state) {
		state.forgotPassword = {
			email: ''
		}
	},

	clearChangePassword (state) {
		state.changePassword = {
			newPassword: '',
			confirmPassword: ''
		}
	},

	signUpcheckForm (state) {
		state.signUpformIsEmpty = true

		for (const key of Object.keys(state.signUp)) {
			const signUpProp = state.signUp[key]

			if (
				((signUpProp.constructor !== Object && signUpProp.constructor !== Array) && signUpProp !== '') ||
				(signUpProp.constructor === Object && Object.keys(signUpProp).length > 0) ||
				(signUpProp.constructor === Array && signUpProp.length > 0)
			) {
				state.signUpformIsEmpty = false
				return
			}
		}
	},

	signUpCheckAllFields (state) {
		state.isCheckedAll = true

		for (const key of Object.keys(state.signUp)) {
			const signUpProp = state.signUp[key]

			if (
				signUpProp === '' ||
				(signUpProp.constructor === Object &&
				!Object.keys(signUpProp).length)
			) {
				state.isCheckedAll = false
				return
			}
		}
	}
}

export const actions = {
	redirect ({commit}, payload) {
		commit('clearSignUp')
		commit('SET_SIGN_UP_ERROR', {}, { root: true })
		payload()
	}
}

export const getters = {
	getField
}



// WEBPACK FOOTER //
// ./src/store/global/model.js